<template>
  <div class="module">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "CModuleContent",
  /////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////
  props: {
    height: {
      type: Number,
      default: 70
    },
    horizontalMargin: {
      type: Number,
      default: 0
    },
    verticalMargin: {
      type: Number,
      default: 0
    }
  },
  /////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////
  computed: {
    renderHeight: function() {
      return this.height + "vh";
    },
    /////////////////////////////////////////////////////////////////////////////
    renderHorizontalMargin: function() {
      return this.horizontalMargin + "vw";
    },
    /////////////////////////////////////////////////////////////////////////////
    renderVerticalMargin: function() {
      return this.verticalMargin + "vh";
    }
  }
}
</script>

<style lang="scss" scoped>
  .module {
    height: v-bind(renderHeight) !important;
    margin-left: v-bind(renderHorizontalMargin);
    margin-right: v-bind(renderHorizontalMargin);
    margin-top: v-bind(renderVerticalMargin);
    margin-bottom: v-bind(renderVerticalMargin);
  }
</style>